@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.welcome {
  text-transform: none;
  margin-top: 1.5rem;
  margin-bottom: 3.75rem;

  @include mobile {
    margin-bottom: 1.5rem;
  }
}

.headline {
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 300;

  @include mobile {
    color: $grey-text;
    font-size: 1rem;
    line-height: 1.125rem;
    margin-bottom: 0.25rem;
  }
}

.text {
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: 300;

  @include mobile {
    color: $grey-text;
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
}